import React from 'react';
import Helmet from 'next/head';
import PropTypes from 'prop-types';

function PageMetadata(props) {
  const {
    title,
    metaTitle,
    metaKeywords,
    metaDescription,
    metaImage,
    orgTitle,
    orgDescription,
    orgImage,
    orgType,
    twitterImage,
    twitterCard,
    nextUrl,
    prevUrl,
  } = props;

  return (
    <Helmet>
      {nextUrl && <link href={nextUrl} rel="next" />}
      {prevUrl && <link href={prevUrl} rel="prev" />}
      <title>{title}</title>
      {metaTitle && <meta name="title" content={metaTitle} />}
      {metaKeywords && <meta name="keywords" content={metaKeywords} />}
      {metaDescription && <meta name="description" content={metaDescription} />}
      {metaImage && <meta name="image" content={metaImage} />}
      {orgTitle && <meta property="og:title" content={orgTitle} />}
      {orgDescription && (
        <meta property="og:description" content={orgDescription} />
      )}
      {orgImage && <meta property="og:image" name="image" content={orgImage} />}
      <meta property="og:url" content="url" />
      {orgType && <meta property="og:type" content={orgType} />}
      {twitterImage && <meta name="twitter:image" content={orgImage} />}
      {twitterCard && <meta name="twitter:card" content={twitterCard} />}
      {orgTitle && <meta name="twitter:title" content={orgTitle} />}
      {orgDescription && (
        <meta name="twitter:description" content={orgDescription} />
      )}
      {twitterImage && <meta name="twitter:site" />}
      {twitterImage && <meta name="twitter:creator" />}
    </Helmet>
  );
}

PageMetadata.propTypes = {
  title: PropTypes.string.isRequired,
  metaTitle: PropTypes.string,
  metaKeywords: PropTypes.string,
  metaDescription: PropTypes.string,
  metaImage: PropTypes.string,
  orgTitle: PropTypes.string,
  orgDescription: PropTypes.string,
  orgImage: PropTypes.string,
  orgType: PropTypes.string,
  twitterImage: PropTypes.string,
  twitterCard: PropTypes.string,
  nextUrl: PropTypes.string,
  prevUrl: PropTypes.string,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const PageMetadata = ({prop = val, metaTitle = '', metaKeywords = '', metaDescription = '', metaImage = '', orgTitle = '', orgDescription = '', orgImage = '', orgType = '', twitterImage = '', twitterCard = '', nextUrl = '', prevUrl = '' }) =>

export default PageMetadata;
